import { render, staticRenderFns } from "./ProjectRepresentative.vue?vue&type=template&id=22869825&scoped=true&"
import script from "./ProjectRepresentative.vue?vue&type=script&lang=js&"
export * from "./ProjectRepresentative.vue?vue&type=script&lang=js&"
import style0 from "./ProjectRepresentative.vue?vue&type=style&index=0&id=22869825&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22869825",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22869825')) {
      api.createRecord('22869825', component.options)
    } else {
      api.reload('22869825', component.options)
    }
    module.hot.accept("./ProjectRepresentative.vue?vue&type=template&id=22869825&scoped=true&", function () {
      api.rerender('22869825', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/projects/ProjectRepresentative.vue"
export default component.exports